import { useState, useEffect } from "react";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db, storage } from "../../../../util/firebase";
import { query, collection, getDocs, where, addDoc } from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";

import { v4 as uuidv4 } from "uuid";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { Button, Modal, ModalBody, Input } from "reactstrap";

function AdminCreateRewardPage() {
  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  // eslint-disable-next-line
  const [userData, setUserData] = useState();
  const fetchUserData = async () => {
    try {
      setIsLoading(true);
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      setUserData(data);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };
  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  const [image, setImage] = useState();
  const [name, setName] = useState("");
  const [priceInTickets, setPriceInTickets] = useState();
  const [quantityAvailable, setQuantityAvailable] = useState();
  const [totalQuantity, setTotalQuantity] = useState();
  const [disclaimer, setDisclaimer] = useState();
  const [isActive, setIsActive] = useState(false);

  const createReward = async () => {
    try {
      setIsLoading(true);

      await addDoc(collection(db, "rewards"), {
        uid: uuidv4(),
        name: name,
        priceInTickets: parseInt(priceInTickets),
        quantityAvailable: parseInt(quantityAvailable),
        totalQuantity: parseInt(totalQuantity),
        image: image
          ? image
          : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3",
        disclaimer: disclaimer,
      });

      navigate(-1);

      setIsLoading(false);
    } catch (err) {
      alert(err.message);
      setIsLoading(false);
    }
  };

  const [newArticleImage, setNewArticleImage] = useState();
  const [newArticleImagePreview, setNewArticleImagePreview] = useState();
  const [changeRewardImageModalIsOpen, setChangeRewardImageModalIsOpen] =
    useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);

  const toggleChangeRewardImageModal = () => {
    setChangeRewardImageModalIsOpen(!changeRewardImageModalIsOpen);
  };

  const handleChangeNewArticleImage = (e) => {
    setNewArticleImage(e.target.files[0]);
    setNewArticleImagePreview(URL.createObjectURL(e.target.files[0]));
  };

  const selectNewArticleImage = () => {
    document.getElementById("selectImage").click();
  };

  const handleUploadNewArticleImage = async () => {
    setIsModalLoading(true);

    const storageRef = ref(storage, `assets/rewards/${newArticleImage.name}`);
    await uploadBytesResumable(storageRef, newArticleImage).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((downloadURL) => {
        setImage(downloadURL);
        setIsModalLoading(false);
        toggleChangeRewardImageModal();
      });
    });
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        CREATE REWARD
      </h1>
      <div>
        <div id="adminNewsArticleImageContainer">
          <img
            alt="newsArticleImage"
            src={
              image
                ? image
                : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
            }
            id="newsArticleImage"
          />
          <div className="adminNewsArticleImageOverlay">
            <Button
              onClick={toggleChangeRewardImageModal}
              className="primaryBtn"
            >
              ADD
            </Button>
            <Modal
              id="changeNewsArticleImageModal"
              isOpen={changeRewardImageModalIsOpen}
              toggle={toggleChangeRewardImageModal}
              size={"lg"}
            >
              <ModalBody>
                <div className="modalHeader" style={{ marginBottom: "1rem" }}>
                  <div></div>
                  <IoClose onClick={toggleChangeRewardImageModal} />
                </div>
                <div>
                  <h1>ADD IMAGE</h1>
                  {isModalLoading ? (
                    <div
                      style={{
                        height: 300,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <BarLoader color="#005EE1" />
                    </div>
                  ) : (
                    <div style={{ marginTop: "1rem" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginBottom: "1rem",
                        }}
                      >
                        <img
                          alt="articleImage"
                          src={
                            newArticleImagePreview
                              ? newArticleImagePreview
                              : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                          }
                          style={{ height: 250, width: 651.4 }}
                        />
                      </div>
                      <Input
                        id="selectImage"
                        type="file"
                        className="mainInput"
                        accept="image/*"
                        onChange={handleChangeNewArticleImage}
                        style={{ display: "none" }}
                      />
                      <Button
                        onClick={selectNewArticleImage}
                        className="secondaryBtn"
                        style={{ marginBottom: "0.5rem", color: "#005EE1" }}
                      >
                        {newArticleImage?.name
                          ? newArticleImage.name
                          : "CHOOSE IMAGE (1,398x1,017px)"}
                      </Button>
                      <Button
                        onClick={handleUploadNewArticleImage}
                        disabled={!newArticleImage?.name}
                        className="primaryBtn"
                      >
                        ADD
                      </Button>
                    </div>
                  )}
                </div>
              </ModalBody>
            </Modal>
          </div>
        </div>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Name
        </p>
        <input
          type="text"
          className="mainInput"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="The reward's name"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Price in tickets
        </p>
        <input
          type="number"
          className="mainInput"
          value={priceInTickets}
          onChange={(e) => setPriceInTickets(e.target.value)}
          placeholder="The reward's price in tickets"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Quantity available
        </p>
        <input
          type="number"
          className="mainInput"
          value={quantityAvailable}
          onChange={(e) => setQuantityAvailable(e.target.value)}
          placeholder="The quantity available for this reward"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Total quantity
        </p>
        <input
          type="number"
          className="mainInput"
          value={totalQuantity}
          onChange={(e) => setTotalQuantity(e.target.value)}
          placeholder="The total quantity for this reward"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Disclaimer
        </p>
        <textarea
          className="mainInput"
          value={disclaimer}
          onChange={(e) => setDisclaimer(e.target.value)}
          placeholder="The reward's disclaimer"
          style={{ marginBottom: "0.5rem", paddingTop: 15, height: 200 }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Is active
        </p>
        <select
          className="mainInput"
          value={isActive}
          onChange={(e) => setIsActive(e.target.value)}
          style={{ marginBottom: "0.5rem" }}
        >
          <option value={true}>Yes</option>
          <option value={false}>No</option>
        </select>
        <Button
          onClick={createReward}
          className="primaryBtn"
          style={{ marginTop: "1rem" }}
          disabled={!name}
        >
          CREATE REWARD
        </Button>
      </div>
    </div>
  );
}

export default AdminCreateRewardPage;
